import type { NamedRef } from '@/types/api'

export type BorrowerKind = 'student' | 'staff'
export type LoanState = 'active' | 'overdue' | 'returned'
export type Availability = 'available' | 'unavailable'

export const LOAN_STATES: LoanState[] = ['active', 'overdue', 'returned']
export const BORROWER_KINDS: BorrowerKind[] = ['student', 'staff']

export interface Book {
  id: number
  title: string
  subtitle: string | null
  authors: string
  isbn: string | null
  publisher: string | null
  publishedYear: number | null
  category: NamedRef | null
  language: string | null
  shelfLocation: string | null
  totalCopies: number
  availableCopies: number
  onLoan: number
  coverUrl: string | null
  description: string | null
  active: boolean
  createdAt: string
  updatedAt: string
}

export interface Loan {
  id: number
  book: { id: number; title: string; authors: string; isbn: string | null; coverUrl: string | null }
  borrower: { kind: BorrowerKind; id: number; name: string; code: string; photoUrl: string | null }
  borrowedOn: string
  dueOn: string
  returnedOn: string | null
  state: LoanState
  daysOverdue: number
  renewCount: number
  canRenew: boolean
  /** Fine recorded at return (decimal string). */
  fineAmount: string
  /** Fine accruing on an open overdue loan (decimal string). */
  accruedFine: string
  finePaid: boolean
  fineOutstanding: boolean
  issuedBy: string | null
  returnedTo: string | null
  notes: string | null
}

export interface BookDetail {
  book: Book
  loans: Loan[]
  timesBorrowed: number
}

export interface Category {
  id: number
  name: string
  bookCount: number
}

export interface Borrower {
  kind: BorrowerKind
  id: number
  name: string
  code: string
  subtitle: string | null
  photoUrl: string | null
  active: boolean
  activeLoans: number
  overdueLoans: number
  loanLimit: number
  finesOutstanding: string
}

export interface BorrowerDetail {
  borrower: Borrower
  loans: Loan[]
}

export interface LibrarySettings {
  loanDays: number
  maxActiveLoansStudent: number
  maxActiveLoansStaff: number
  finePerDay: string
  currency: string
}

export interface LibraryStats {
  titles: number
  copies: number
  onLoan: number
  overdue: number
  finesOutstanding: string
  currency: string
}

export interface BookFilters {
  categoryId?: string
  availability?: string
  status?: string
  language?: string
}

export interface LoanFilters {
  state?: string
  borrowerKind?: string
  fines?: string
  bookId?: string
}

export interface StaffLibraryData {
  linked: boolean
  borrower: Borrower | null
  loans: Loan[]
}

export interface FamilyLibraryData {
  borrower: Borrower
  loans: Loan[]
}
